import HomeRoute from './Home';
import ProjectRoute from './Project';
import SubSequence from './SubSequence';
import ArchiveRoute from './Archive';
import AboutRoute from './About';

export default [HomeRoute, ProjectRoute, SubSequence, ArchiveRoute, AboutRoute];
